module.exports = __webpack_public_path__ + "static/img/Thomas-Mcguane.90c43fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Mcguane.jpg
// module id = yTtc
// module chunks = 0